/**
 * 
 * @param {Array} inputList 
 * @returns {Array} options
 */
function mapOptions(inputList) {
    const transformedList =
        Array.isArray(inputList) &&
        inputList.map(input => {
            return input.name;
        });
    const options = transformedList || [];
    return options;
}

export default mapOptions;